var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image__container",class:_vm.customClass},[_c('img',{staticClass:"image",class:_vm.load,style:(_vm.imageStyle),attrs:{"width":_vm.width ? _vm.width : null,"height":_vm.height ? _vm.height : null,"alt":_vm.alt,"aria-label":_vm.alt,"data-src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }